module.exports = __webpack_public_path__ + "static/media/suyog_arlimar.95b8d3f8.jpg";